/**
 * Rank lib section
 */
export const rankLibHeaders = [
  {
    text: "Id",
    align: "left",
    sortable: true,
    value: "node.rankId"
  },
  { text: "Rank Code", value: "node.rankCode" },
  { text: "Rank Name", value: "node.rankName", color: "node.rankColor" },
  {
    text: "Rank Description",
    value: "node.rankDesc"
  },
  {
    text: "Rank Classification",
    value: "node.rankClassification"
  },
  {
    text: "Rank Color",
    value: "node.rankColor"
  },
  { text: "Actions", value: "action", sortable: false }
];

export const rankDefaultData = {
  rankCode: "",
  rankName: "",
  rankDesc: "",
  rankClassification: "",
  rankColor: ""
};
/**
 * Meet Section
 */
export const meetHeaders = [
  {
    text: "MeetId",
    align: "left",
    sortable: true,
    value: "node.meetId"
  },
  {
    text: "Meet Name",
    align: "left",
    sortable: true,
    value: "node.meetName"
  },
  {
    text: "contactInfo",
    align: "left",
    sortable: true,
    value: "node.contactInfo"
  },
  {
    text: "meetType",
    align: "left",
    sortable: true,
    value: "node.meetType"
  },
  {
    text: "meetDate",
    align: "left",
    sortable: true,
    value: "node.meetDate"
  },
  {
    text: "meetDateTo",
    align: "left",
    sortable: true,
    value: "node.meetDateTo"
  },
  { text: "Actions", value: "action", sortable: false }
];
export const meetDefaultData = {
  meetName: "",
  meetDesc: "",
  contactInfo: "",
  meetType: "",
  meetDate: "", // Date
  meetDateTo: "", // Date
  facilityId: "",
  sport: "",
  urlToDetails: "",
  state: "",
  tag: "",
  leagueSeqno: null,
  updateSource: "test"
};
export const rankResultsTable = [
  {
    text: "Athlete",
    align: "left",
    sortable: true,
    value: "firstName",
    class: ["column-color"]
  },
  { text: "Rank", value: "athRankName", class: ["column-color"] },
  { text: "Event", value: "distance", class: ["column-color"] },
  //{ text: "Stroke", value: "stroke", class: ["column-color"], sortable: true },
  {
    text: "Date",
    value: "resultDate",
    class: ["column-color"],
    sortable: true
  },
  { text: "Result", value: "resultTime", class: ["column-color"] },
  { text: "Comments", value: "comments", class: ["column-color"] },
  { text: "Place", value: "place", class: ["column-color"] },
  {
    text: "Facility",
    value: "facilityType",
    class: ["column-color"]
  },
  {
    text: "Next Rank",
    value: "timeToNextRank",
    class: ["column-color"]
  },
  { text: "Meet", value: "meetName", class: ["column-color"] },  
  { text: "Pts", value: "points", class: ["column-color"] },
  { text: "Actions", value: "action", sortable: false }
];
